import React, { useState } from 'react';
import { styled } from '@mui/material';

import Input from '../../../components/Input';

interface StreamContentProps {
  metadata: {
    [propertyName: string]: any;
  };
  onChange: (propertyName: string, value: any) => void;
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  & > label {
    padding-top: 15px;
    color: var(--Secondary-60, #a1a1a1);
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  & > div {
    & > input {
      color: #3e3e3e;
    }
    & > input::placeholder {
      color: #a1a1a1;
    }
  }
`;

const StreamContent: React.FC<StreamContentProps> = ({
  metadata,
  onChange,
}) => {
  const [streamMetaData, setStreamMetaData] = useState<{
    [propertyName: string]: any;
  }>({
    livekitEndpointUrl: metadata?.livekitEndpointUrl || '',
    livekitApiKey: metadata?.livekitApiKey || '',
    livekitApiSecret: metadata?.livekitApiSecret || '',
    s3EndpointUrl: metadata?.s3EndpointUrl || '',
    s3AccessKeyId: metadata?.s3AccessKeyId || '',
    s3SecretAccessKey: metadata?.s3SecretAccessKey || '',
    s3BucketName: metadata?.s3BucketName || '',
  });

  return (
    <Container>
      <label>LiveKit Endpoint URL</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.livekitEndpointUrl || ''}
        placeholder={'LiveKit Endpoint URL'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            livekitEndpointUrl: e.target.value,
          });
          onChange('livekitEndpointUrl', e.target.value);
        }}
      />
      <label>LiveKit API Key</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.livekitApiKey || ''}
        placeholder={'LiveKit API Key'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            livekitApiKey: e.target.value,
          });
          onChange('livekitApiKey', e.target.value);
        }}
      />
      <label>LiveKit API Secret</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.livekitApiSecret || ''}
        placeholder={'LiveKit API Secret'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            livekitApiSecret: e.target.value,
          });
          onChange('livekitApiSecret', e.target.value);
        }}
      />
      <label>S3 Endpoint URL</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.s3EndpointUrl || ''}
        placeholder={'S3 Endpoint URL'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            s3EndpointUrl: e.target.value,
          });
          onChange('s3EndpointUrl', e.target.value);
        }}
      />
      <label>S3 Access Key ID</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.s3AccessKeyId || ''}
        placeholder={'S3 Access Key ID'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            s3AccessKeyId: e.target.value,
          });
          onChange('s3AccessKeyId', e.target.value);
        }}
      />
      <label>S3 Secret Access Key</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.s3SecretAccessKey || ''}
        placeholder={'S3 Secret Access Key'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            s3SecretAccessKey: e.target.value,
          });
          onChange('s3SecretAccessKey', e.target.value);
        }}
      />
      <label>S3 Bucket Name</label>
      <Input
        sx={{ width: '100%', display: 'block', placeholderShown: 'true' }}
        value={streamMetaData?.s3BucketName || ''}
        placeholder={'S3 Bucket Name'}
        onChange={(e) => {
          setStreamMetaData({
            ...streamMetaData,
            s3BucketName: e.target.value,
          });
          onChange('s3BucketName', e.target.value);
        }}
      />
    </Container>
  );
};

export default StreamContent;
